// extracted by mini-css-extract-plugin
export default {"buttons":"ToDoControls_buttons__-uJ2X","button":"ToDoControls_button__6hIsg","circle":"ToDoControls_circle__uZFS2"};